import { render, staticRenderFns } from "./edit-ip.vue?vue&type=template&id=88b53a78&scoped=true"
import script from "./edit-ip.vue?vue&type=script&lang=js"
export * from "./edit-ip.vue?vue&type=script&lang=js"
import style0 from "./edit-ip.vue?vue&type=style&index=0&id=88b53a78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b53a78",
  null
  
)

export default component.exports